<template>
	
	<div class="empty-ticket-list">
		
		<div class="empty-ticket-list__inner">
			
			<img class="empty-ticket-list__icon" src="@/assets/404.svg" height="160" alt="">
			
			<p class="empty-ticket-list__description">This project has no tasks</p>
			
			<el-button class="empty-ticket-list__button" type="brand" size="small" icon="el-icon-plus" round @click="onClickButton">Add Task</el-button>
			
		</div>
		
	</div>
	
</template>

<script>
	
	export default {
		
		methods: {
			onClickButton() {
				this.$emit("on-click-button");
			},
		}
		
	}
	
</script>

<style scoped>
	
	
	
</style>


// WEBPACK FOOTER //
// src/components/Projects/Project/TicketsListEmpty.vue